import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import type { CompanyHubSettingsPageTabsType } from './CompanyHubSettingsPage.ts';

export { CompanyHubSettingsPageTabsType } from '../src/hub-settings/CompanyHubSettingsPageTabsType.ts';
export const CompanyHubSettingsPage: LoadableType<{
	tab?: CompanyHubSettingsPageTabsType;
}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-BulkCompanyHubSettingsPage" */ '../src/hub-settings/CompanyHubSettingsPage.tsx'
			)
		).CompanyHubSettingsPage,
	name: 'CompanyHubSettingsPage',
});
